import CreatorCodePromotionCreate from "./CreatorCodePromotionCreate";

export default CreatorCodePromotionCreate;
